function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Vehicle",
  transform: "translate(-537.761 -277.317)"
}, React.createElement("path", {
  id: "Path_154",
  "data-name": "Path 154",
  d: "M627.608,796.073l125.481-73.565L923.735,822.6,798.254,896.17Z",
  transform: "translate(-65.977 -326.914)",
  fill: "#414141",
  opacity: 0.21
}), React.createElement("g", {
  id: "Group_66",
  "data-name": "Group 66",
  transform: "translate(798.305 361.541)"
}, React.createElement("path", {
  id: "Path_155",
  "data-name": "Path 155",
  d: "M1530.9,597.4l-7,4.069-.054,15.353,7-4.069Z",
  transform: "translate(-1522.412 -596.584)",
  fill: "#30302f"
}), React.createElement("path", {
  id: "Path_156",
  "data-name": "Path 156",
  d: "M1530.9,664.042l-7,4.069-.054,8.986,7-4.069Z",
  transform: "translate(-1522.412 -645.522)",
  fill: "#30302f"
}), React.createElement("path", {
  id: "Path_157",
  "data-name": "Path 157",
  d: "M1518.645,598.4l1.437.815,7-4.069-1.437-.815Z",
  transform: "translate(-1518.59 -594.332)",
  fill: "#4d4c4c"
}), React.createElement("path", {
  id: "Path_158",
  "data-name": "Path 158",
  d: "M1518.495,609.647l1.437.815-.054,15.353-1.437-.815Z",
  transform: "translate(-1518.441 -605.578)",
  fill: "#373737"
}), React.createElement("path", {
  id: "Path_159",
  "data-name": "Path 159",
  d: "M1525.646,660.974l1.437.815-7,4.069-1.437-.815Z",
  transform: "translate(-1518.59 -643.269)",
  fill: "#4d4c4c"
}), React.createElement("path", {
  id: "Path_160",
  "data-name": "Path 160",
  d: "M1518.495,676.287l1.437.815-.054,8.986-1.437-.815Z",
  transform: "translate(-1518.441 -654.514)",
  fill: "#373737"
})), React.createElement("g", {
  id: "Group_68",
  "data-name": "Group 68",
  transform: "translate(553.815 335.343)"
}, React.createElement("g", {
  id: "Group_67",
  "data-name": "Group 67",
  transform: "translate(0.051 0)"
}, React.createElement("path", {
  id: "Path_161",
  "data-name": "Path 161",
  d: "M1067.838,810.363l-.017,6.019-.035,24.364,74.819-43.515.034-24.364.017-6.019Z",
  transform: "translate(-943.076 -694.817)",
  fill: "#242e39"
}), React.createElement("path", {
  id: "Path_162",
  "data-name": "Path 162",
  d: "M747.583,538.671l-50.912-29.394L673.2,495.724l-74.819,43.514,23.474,13.552,50.913,29.394,50.376,29.085,74.819-43.515Z",
  transform: "translate(-598.378 -495.724)",
  fill: "#3d4956"
})), React.createElement("path", {
  id: "Path_163",
  "data-name": "Path 163",
  d: "M723,731.543l-.017,6.019-.034,24.364L598.187,689.895l.051-30.384,23.474,13.552,50.912,29.394Z",
  transform: "translate(-598.187 -615.997)",
  fill: "#13212b"
}), React.createElement("path", {
  id: "Path_164",
  "data-name": "Path 164",
  d: "M723,755.973l-.017,6.019-.034,1.643L598.187,691.6l.051-7.663,23.474,13.553,50.912,29.395Z",
  transform: "translate(-598.187 -633.936)",
  fill: "#c38f2c"
})), React.createElement("g", {
  id: "Group_75",
  "data-name": "Group 75",
  transform: "translate(649.992 457.037)"
}, React.createElement("path", {
  id: "Path_165",
  "data-name": "Path 165",
  d: "M1045.48,1185.293l26.161-17.769-.942,1.546-26.161,17.769Z",
  transform: "translate(-1022.13 -1110.737)",
  fill: "#30302f"
}), React.createElement("path", {
  id: "Path_166",
  "data-name": "Path 166",
  d: "M995.66,1061.413l1.8-.284L971.3,1078.9l-1.8.284Z",
  transform: "translate(-967.027 -1032.608)",
  fill: "#30302f"
}), React.createElement("path", {
  id: "Path_167",
  "data-name": "Path 167",
  d: "M1102.489,1215.058l26.161-17.768.162,2.4-26.16,17.769Z",
  transform: "translate(-1064.685 -1132.594)",
  fill: "#30302f"
}), React.createElement("path", {
  id: "Path_168",
  "data-name": "Path 168",
  d: "M987.147,995.82l2.175,1.059-26.16,17.769-2.175-1.06Z",
  transform: "translate(-960.776 -984.65)",
  fill: "#30302f"
}), React.createElement("path", {
  id: "Path_169",
  "data-name": "Path 169",
  d: "M1171.424,1203.24l1.231,2.616-22.365,15.254-1.231-2.616Z",
  transform: "translate(-1098.882 -1136.963)",
  fill: "#30302f"
}), React.createElement("path", {
  id: "Path_170",
  "data-name": "Path 170",
  d: "M1002.334,966.768l1.966,2.12-19.635,13.4-1.966-2.12Z",
  transform: "translate(-976.721 -963.317)",
  fill: "#30302f"
}), React.createElement("path", {
  id: "Path_171",
  "data-name": "Path 171",
  d: "M1195.043,1174.6l1.958,2.113-19.634,13.4-1.958-2.113Z",
  transform: "translate(-1118.231 -1115.932)",
  fill: "#373737"
}), React.createElement("path", {
  id: "Path_172",
  "data-name": "Path 172",
  d: "M1169.055,1195.955l19.634-13.4a16.468,16.468,0,0,1-4.965,8.119l-19.634,13.4A16.463,16.463,0,0,0,1169.055,1195.955Z",
  transform: "translate(-1109.919 -1121.773)",
  fill: "#4d4c4c"
}), React.createElement("path", {
  id: "Path_173",
  "data-name": "Path 173",
  d: "M1048.276,954.223l1.223,2.6-19.634,13.4-1.223-2.6Z",
  transform: "translate(-1010.457 -954.104)",
  fill: "#373737"
}), React.createElement("path", {
  id: "Path_174",
  "data-name": "Path 174",
  d: "M1001.071,967.191c-.288-.011-.572-.013-.854-.012-.112,0-.227,0-.338,0q-.569.013-1.121.059c-.086.007-.168.019-.253.027-.29.028-.576.062-.858.1-.107.016-.213.034-.319.052q-.416.07-.822.162c-.078.017-.158.032-.236.051q-.5.121-.991.274c-.076.024-.149.05-.224.076q-.389.128-.766.277c-.086.034-.173.068-.259.1-.313.131-.621.268-.922.42l19.634-13.4.015-.008c.3-.149.6-.285.907-.412.086-.036.172-.07.259-.1.1-.041.2-.085.309-.124.15-.055.3-.1.456-.153.076-.025.149-.052.224-.076.3-.093.6-.179.9-.255.03-.007.061-.012.091-.02.078-.019.158-.034.236-.051q.405-.091.822-.162c.106-.019.212-.036.319-.052.083-.012.165-.029.249-.04.2-.027.4-.045.607-.065.085-.009.168-.02.254-.027.341-.028.687-.049,1.038-.059.027,0,.056,0,.083,0,.111,0,.226,0,.339,0,.282,0,.566,0,.854.012.146.006.294.016.441.024s.3.013.447.024c.2.016.391.035.589.056l-19.634,13.4c-.35-.038-.694-.06-1.036-.081C1001.364,967.207,1001.217,967.2,1001.071,967.191Z",
  transform: "translate(-984.363 -953.776)",
  fill: "#4d4c4c"
}), React.createElement("path", {
  id: "Path_175",
  "data-name": "Path 175",
  d: "M1176,1177.025l19.634-13.4a22.887,22.887,0,0,1-.586,2.916l-19.634,13.4A22.967,22.967,0,0,0,1176,1177.025Z",
  transform: "translate(-1118.231 -1107.871)",
  fill: "#30302f"
}), React.createElement("path", {
  id: "Path_176",
  "data-name": "Path 176",
  d: "M1035.218,977.754c-.158-.034-.316-.068-.472-.1s-.337-.062-.5-.09c-.084-.015-.169-.031-.252-.044-.251-.04-.5-.076-.746-.107l19.634-13.4q.37.047.745.107c.083.013.168.029.252.044.168.028.335.057.5.09l.051.01c.139.027.279.058.42.089.08.017.16.033.241.051.24.055.481.112.724.176l-19.634,13.4c-.243-.064-.484-.121-.724-.176C1035.378,977.787,1035.3,977.771,1035.218,977.754Z",
  transform: "translate(-1013.836 -961.293)",
  fill: "#30302f"
}), React.createElement("path", {
  id: "Path_177",
  "data-name": "Path 177",
  d: "M1183.588,1140.2c-.034-.5-.081-1.007-.135-1.513-.018-.166-.041-.332-.061-.5-.041-.344-.085-.689-.136-1.035-.028-.193-.059-.387-.09-.58q-.077-.486-.166-.974c-.036-.2-.072-.4-.11-.593-.089-.457-.18-.913-.282-1.372l19.634-13.4q.112.5.214,1.006c.024.122.044.244.068.366.039.2.075.4.111.593.06.325.113.65.166.974.031.193.061.386.089.578.051.347.094.692.136,1.036.02.166.043.331.061.5.054.506.1,1.011.135,1.513a32.764,32.764,0,0,1-.131,6.022l-19.633,13.4A32.86,32.86,0,0,0,1183.588,1140.2Z",
  transform: "translate(-1123.518 -1076.014)",
  fill: "#4d4c4c"
}), React.createElement("g", {
  id: "Group_69",
  "data-name": "Group 69",
  transform: "translate(56.915 43.166)"
}, React.createElement("path", {
  id: "Path_178",
  "data-name": "Path 178",
  d: "M1176.595,1130.711l19.635-13.4-2.175-1.06-19.634,13.4Z",
  transform: "translate(-1174.42 -1116.25)",
  fill: "#373737"
})), React.createElement("path", {
  id: "Path_179",
  "data-name": "Path 179",
  d: "M1171.217,1118.043c-.063-.237-.128-.474-.2-.711-.031-.108-.062-.216-.094-.324-.127-.435-.258-.869-.4-1.3l19.634-13.4c.138.435.269.869.4,1.3.016.055.034.11.05.165s.029.106.044.16q.1.356.2.712c.03.11.061.221.09.332q.136.518.258,1.035l-19.634,13.4c-.081-.345-.168-.69-.258-1.035C1171.277,1118.265,1171.246,1118.154,1171.217,1118.043Z",
  transform: "translate(-1114.649 -1062.843)",
  fill: "#30302f"
}), React.createElement("path", {
  id: "Path_180",
  "data-name": "Path 180",
  d: "M1106.827,987.04c1.037.734,2.057,1.525,3.058,2.356l-19.634,13.4c-1-.831-2.021-1.622-3.058-2.355Z",
  transform: "translate(-1053.452 -978.202)",
  fill: "#30302f"
}), React.createElement("path", {
  id: "Path_181",
  "data-name": "Path 181",
  d: "M1086.582,991.411l19.634-13.4.162,2.4-19.634,13.4Z",
  transform: "translate(-1053.004 -971.572)",
  fill: "#373737"
}), React.createElement("path", {
  id: "Path_182",
  "data-name": "Path 182",
  d: "M1047.353,971.776l-.127-.053c-.3-.124-.607-.241-.909-.354l-.231-.085q-.373-.137-.743-.261l-.2-.068c-.163-.054-.326-.1-.489-.156-.081-.025-.161-.052-.242-.076q-.354-.108-.7-.205l-.018,0h0l19.634-13.4q.36.1.723.211c.079.023.158.05.236.074.164.051.328.1.494.158l.066.021.131.046q.371.125.744.262l.23.084c.3.113.6.23.908.354l.128.054q.4.167.808.346l.247.11c.312.141.624.286.939.439a44.262,44.262,0,0,1,5.739,3.393l-19.634,13.4a44.21,44.21,0,0,0-5.739-3.392c-.315-.153-.627-.3-.939-.439l-.247-.11Q1047.755,971.942,1047.353,971.776Z",
  transform: "translate(-1021.508 -956.224)",
  fill: "#4d4c4c"
}), React.createElement("path", {
  id: "Path_183",
  "data-name": "Path 183",
  d: "M1137.421,1051.121l19.633-13.4q.533.736,1.046,1.487c.025.037.047.074.073.111q.633.934,1.236,1.888l-19.634,13.4q-.6-.955-1.236-1.888Q1137.991,1051.913,1137.421,1051.121Z",
  transform: "translate(-1090.336 -1015.417)",
  fill: "#30302f"
}), React.createElement("path", {
  id: "Path_184",
  "data-name": "Path 184",
  d: "M1165.913,1050.06l1.8-.283-19.635,13.4-1.8.283Z",
  transform: "translate(-1096.84 -1024.271)",
  fill: "#373737"
}), React.createElement("path", {
  id: "Path_185",
  "data-name": "Path 185",
  d: "M1158.757,1074.745q-.2-.529-.405-1.058c-.077-.2-.155-.394-.235-.589q-.24-.591-.494-1.18c-.055-.127-.107-.254-.163-.381q-.341-.78-.705-1.554c-.048-.1-.1-.206-.148-.309q-.3-.623-.608-1.243-.114-.228-.23-.454-.332-.649-.679-1.292c-.04-.076-.08-.151-.121-.227-.26-.477-.528-.951-.8-1.424-.359-.622-.725-1.242-1.1-1.855l19.635-13.4q.568.92,1.1,1.856c.03.052.063.1.093.156q.359.63.705,1.266c.042.077.081.154.123.231.163.3.326.6.483.906.066.127.129.255.194.381.078.152.155.3.231.457q.31.617.606,1.238c.05.1.1.208.15.313l.051.106q.337.721.654,1.446c.056.128.108.256.164.384.116.271.234.54.346.811.05.122.1.244.146.367.08.2.158.392.236.589q.208.528.4,1.057c.072.192.144.384.213.576.034.1.071.189.1.284q.221.623.428,1.247h0l-19.634,13.4c-.168-.512-.348-1.023-.533-1.533C1158.9,1075.127,1158.828,1074.936,1158.757,1074.745Z",
  transform: "translate(-1101.824 -1024.272)",
  fill: "#4d4c4c"
}), React.createElement("path", {
  id: "Path_186",
  "data-name": "Path 186",
  d: "M1111.226,1012.859q-.44-.558-.889-1.108c-.14-.171-.282-.34-.423-.509q-.367-.438-.738-.869-.223-.258-.448-.513c-.229-.26-.461-.516-.693-.771-.2-.216-.4-.433-.595-.647-.226-.241-.454-.478-.682-.716-.2-.209-.4-.418-.607-.624-.184-.185-.371-.367-.556-.55q-.512-.5-1.032-.994-.275-.258-.552-.514-.547-.5-1.1-.986c-.215-.188-.428-.381-.646-.565l19.634-13.4.293.25c.119.1.235.211.354.316q.555.484,1.1.985.278.255.553.515.521.488,1.032.993c.111.109.224.213.334.322.075.075.147.152.221.228.2.206.406.415.609.625.228.237.456.474.681.715.2.214.4.43.595.647.135.147.272.291.4.44.1.109.192.221.289.331.15.169.3.34.446.511q.373.431.739.87c.141.169.282.338.422.508.066.081.134.159.2.24.232.287.46.577.69.868.065.082.131.163.2.247q.484.621.954,1.254l.176.238-19.634,13.4q-.556-.754-1.13-1.492C1111.357,1013.023,1111.291,1012.942,1111.226,1012.859Z",
  transform: "translate(-1064.518 -980.445)",
  fill: "#4d4c4c"
}), React.createElement("g", {
  id: "Group_70",
  "data-name": "Group 70",
  transform: "translate(0 13.396)"
}, React.createElement("path", {
  id: "Path_187",
  "data-name": "Path 187",
  d: "M988.034,1007.248a33.094,33.094,0,0,0-5.657-2.159l.162,2.4a23.225,23.225,0,0,0-2.938-.566l-1.223-2.6a16.692,16.692,0,0,0-9.441,1.489l1.228,2.612a12.561,12.561,0,0,0-2.027,1.352l-1.966-2.12a16.489,16.489,0,0,0-4.965,8.119l1.958,2.11a22.987,22.987,0,0,0-.587,2.917l-2.175-1.06a32.87,32.87,0,0,0-.131,6.022,43.958,43.958,0,0,0,.98,6.563l2.176,1.06c.289,1.231.639,2.47,1.033,3.706l-1.8.284a65,65,0,0,0,6.435,13.673l1.8-.283q1.12,1.777,2.353,3.484l-.947,1.555a65.206,65.206,0,0,0,10.29,11.1l.942-1.546c1,.834,2.022,1.622,3.059,2.355l.162,2.4a44.537,44.537,0,0,0,5.739,3.39,33.424,33.424,0,0,0,5.656,2.163l-.162-2.4a22.752,22.752,0,0,0,2.938.566l1.225,2.6a16.7,16.7,0,0,0,9.441-1.486l-1.231-2.616a12.7,12.7,0,0,0,2.027-1.349l1.966,2.119a16.466,16.466,0,0,0,4.965-8.119l-1.958-2.113a22.967,22.967,0,0,0,.587-2.916l2.175,1.06a32.867,32.867,0,0,0,.13-6.022,43.921,43.921,0,0,0-.981-6.563l-2.175-1.06c-.289-1.231-.639-2.467-1.034-3.706l1.8-.281a64.928,64.928,0,0,0-6.436-13.674l-1.8.283q-1.12-1.782-2.353-3.487l.949-1.55a65.453,65.453,0,0,0-10.29-11.1l-.945,1.544c-1-.831-2.021-1.622-3.058-2.355l-.162-2.4A44.244,44.244,0,0,0,988.034,1007.248Z",
  transform: "translate(-960.194 -1004.197)",
  fill: "#373737"
})), React.createElement("path", {
  id: "Path_188",
  "data-name": "Path 188",
  d: "M1138.37,1045.285l19.635-13.4-.95,1.55-19.633,13.4Z",
  transform: "translate(-1090.335 -1011.132)",
  fill: "#373737"
}), React.createElement("g", {
  id: "Group_73",
  "data-name": "Group 73",
  transform: "translate(12.132 29.958)"
}, React.createElement("g", {
  id: "Group_71",
  "data-name": "Group 71"
}, React.createElement("path", {
  id: "Path_189",
  "data-name": "Path 189",
  d: "M1021.488,1068.269c8.764,4.271,16.461,15.174,17.9,25.01q.131.9.192,1.787c.693,10.271-6.282,14.922-15.581,10.392s-17.4-16.527-18.091-26.8q-.06-.886-.044-1.716C1006.025,1067.888,1012.725,1064,1021.488,1068.269Z",
  transform: "translate(-1005.859 -1066.535)",
  fill: "#bbbcbe"
})), React.createElement("g", {
  id: "Group_72",
  "data-name": "Group 72",
  transform: "translate(4.604 5.544)"
}, React.createElement("path", {
  id: "Path_190",
  "data-name": "Path 190",
  d: "M1034.556,1088.664c6.374,3.106,11.972,11.035,13.017,18.189q.1.656.14,1.3c.5,7.47-4.568,10.853-11.333,7.558s-12.653-12.02-13.157-19.49q-.044-.645-.032-1.248C1023.31,1088.386,1028.183,1085.558,1034.556,1088.664Z",
  transform: "translate(-1023.189 -1087.403)",
  fill: "#919396"
})), React.createElement("path", {
  id: "Path_191",
  "data-name": "Path 191",
  d: "M1023.188,1094.937c.1-5.458,3.461-8.33,8.236-7.391-3.643.167-6.072,2.935-6.155,7.559-.007.4,0,.818.032,1.248.5,7.469,6.4,16.2,13.158,19.49a12.836,12.836,0,0,0,3.14,1.085,10.9,10.9,0,0,1-5.223-1.253c-6.762-3.295-12.653-12.02-13.157-19.49C1023.191,1095.755,1023.181,1095.339,1023.188,1094.937Z",
  transform: "translate(-1018.583 -1081.835)",
  fill: "#d0d1d2"
})), React.createElement("g", {
  id: "Group_74",
  "data-name": "Group 74",
  transform: "translate(21.723 40.307)"
}, React.createElement("path", {
  id: "Path_192",
  "data-name": "Path 192",
  d: "M1052.548,1148.008a.9.9,0,0,0-.9-.027c-.472.315-.411,1.228.138,2.04a2.559,2.559,0,0,0,.952.873.9.9,0,0,0,.9.027c.472-.315.41-1.228-.138-2.04A2.554,2.554,0,0,0,1052.548,1148.008Z",
  transform: "translate(-1048.845 -1136.613)",
  fill: "#3a3e3f"
}), React.createElement("path", {
  id: "Path_193",
  "data-name": "Path 193",
  d: "M1065.579,1128.782c-1.639-.8-2.869.022-2.746,1.832a6.278,6.278,0,0,0,3.189,4.725c1.639.8,2.869-.021,2.746-1.833A6.282,6.282,0,0,0,1065.579,1128.782Z",
  transform: "translate(-1057.281 -1122.37)",
  fill: "#3a3e3f"
}), React.createElement("path", {
  id: "Path_194",
  "data-name": "Path 194",
  d: "M1072.33,1166.136c-.721-.351-1.262.009-1.209.806a2.766,2.766,0,0,0,1.4,2.079c.721.351,1.262-.01,1.208-.806A2.762,2.762,0,0,0,1072.33,1166.136Z",
  transform: "translate(-1063.371 -1149.924)",
  fill: "#3a3e3f"
}), React.createElement("path", {
  id: "Path_195",
  "data-name": "Path 195",
  d: "M1090.928,1166.707a.9.9,0,0,0-.9-.027c-.472.314-.411,1.227.138,2.04a2.559,2.559,0,0,0,.951.873.9.9,0,0,0,.9.027c.471-.316.409-1.229-.138-2.04A2.565,2.565,0,0,0,1090.928,1166.707Z",
  transform: "translate(-1077.028 -1150.344)",
  fill: "#3a3e3f"
}), React.createElement("path", {
  id: "Path_196",
  "data-name": "Path 196",
  d: "M1049.689,1105.623a.9.9,0,0,0-.9-.028c-.473.314-.411,1.228.137,2.039a2.56,2.56,0,0,0,.952.872.9.9,0,0,0,.9.028c.473-.314.41-1.228-.137-2.039A2.554,2.554,0,0,0,1049.689,1105.623Z",
  transform: "translate(-1046.745 -1105.489)",
  fill: "#3a3e3f"
}), React.createElement("path", {
  id: "Path_197",
  "data-name": "Path 197",
  d: "M1068.482,1109.078c.721.351,1.262-.01,1.208-.806a2.764,2.764,0,0,0-1.4-2.079c-.722-.352-1.263.009-1.209.806A2.763,2.763,0,0,0,1068.482,1109.078Z",
  transform: "translate(-1060.402 -1105.908)",
  fill: "#3a3e3f"
}), React.createElement("path", {
  id: "Path_198",
  "data-name": "Path 198",
  d: "M1088.262,1127.207a.9.9,0,0,0,.9.028c.472-.315.41-1.228-.137-2.039a2.558,2.558,0,0,0-.953-.872.9.9,0,0,0-.895-.028c-.472.314-.411,1.228.138,2.04A2.555,2.555,0,0,0,1088.262,1127.207Z",
  transform: "translate(-1074.927 -1119.221)",
  fill: "#3a3e3f"
}), React.createElement("path", {
  id: "Path_199",
  "data-name": "Path 199",
  d: "M1044.576,1125.022a2.764,2.764,0,0,0-1.4-2.079c-.721-.351-1.262.009-1.208.806a2.765,2.765,0,0,0,1.4,2.079C1044.088,1126.18,1044.629,1125.819,1044.576,1125.022Z",
  transform: "translate(-1041.96 -1118.208)",
  fill: "#3a3e3f"
}), React.createElement("path", {
  id: "Path_200",
  "data-name": "Path 200",
  d: "M1097.445,1149.388c-.721-.351-1.263.009-1.209.806a2.765,2.765,0,0,0,1.4,2.079c.722.352,1.263-.01,1.209-.806A2.763,2.763,0,0,0,1097.445,1149.388Z",
  transform: "translate(-1081.814 -1137.626)",
  fill: "#3a3e3f"
})), React.createElement("path", {
  id: "Path_201",
  "data-name": "Path 201",
  d: "M976.678,1044.613c1.026,15.207,13.061,33.035,26.829,39.743a22.246,22.246,0,0,0,11.149,2.569,12.821,12.821,0,0,0,6.344-2.113c4.454-3,6.629-8.755,6.126-16.213-.06-.873-.156-1.77-.287-2.664a51.233,51.233,0,0,0-9.188-21.632c-4.924-6.908-11.086-12.394-17.355-15.448-6.557-3.195-12.619-3.454-17.067-.728-4.153,2.545-6.5,7.49-6.619,13.923h0C976.6,1042.881,976.619,1043.743,976.678,1044.613Zm1.072-.072c-.057-.84-.078-1.671-.064-2.471h0c.108-6.054,2.277-10.68,6.106-13.026a11.87,11.87,0,0,1,5.434-1.677,21.2,21.2,0,0,1,10.6,2.455c12.675,6.176,23.831,21.769,25.95,36.269.126.867.22,1.736.277,2.58.477,7.059-1.532,12.475-5.654,15.25-4.153,2.795-9.985,2.606-16.423-.531C990.519,1076.832,978.754,1059.4,977.75,1044.541Z",
  transform: "translate(-972.247 -1007)",
  fill: "#4d4c4c"
})), React.createElement("g", {
  id: "Group_82",
  "data-name": "Group 82",
  transform: "translate(538.392 392.058)"
}, React.createElement("path", {
  id: "Path_202",
  "data-name": "Path 202",
  d: "M625.424,940.716l26.161-17.769-.943,1.546-26.16,17.769Z",
  transform: "translate(-602.073 -866.159)",
  fill: "#30302f"
}), React.createElement("path", {
  id: "Path_203",
  "data-name": "Path 203",
  d: "M575.6,816.834l1.8-.284-26.16,17.769-1.8.284Z",
  transform: "translate(-546.971 -788.03)",
  fill: "#30302f"
}), React.createElement("path", {
  id: "Path_204",
  "data-name": "Path 204",
  d: "M682.432,970.48l26.16-17.769.163,2.4-26.161,17.769Z",
  transform: "translate(-644.627 -888.015)",
  fill: "#30302f"
}), React.createElement("path", {
  id: "Path_205",
  "data-name": "Path 205",
  d: "M567.09,751.241l2.175,1.06L543.1,770.07l-2.175-1.06Z",
  transform: "translate(-540.719 -740.071)",
  fill: "#30302f"
}), React.createElement("path", {
  id: "Path_206",
  "data-name": "Path 206",
  d: "M751.366,958.663l1.231,2.616-22.364,15.253L729,973.917Z",
  transform: "translate(-678.825 -892.386)",
  fill: "#30302f"
}), React.createElement("path", {
  id: "Path_207",
  "data-name": "Path 207",
  d: "M582.278,722.189l1.965,2.12-19.634,13.4-1.966-2.12Z",
  transform: "translate(-556.664 -718.738)",
  fill: "#30302f"
}), React.createElement("path", {
  id: "Path_208",
  "data-name": "Path 208",
  d: "M774.986,930.022l1.957,2.113-19.634,13.4-1.958-2.113Z",
  transform: "translate(-698.174 -871.354)",
  fill: "#373737"
}), React.createElement("path", {
  id: "Path_209",
  "data-name": "Path 209",
  d: "M749,951.377l19.634-13.4a16.459,16.459,0,0,1-4.965,8.119l-19.634,13.4A16.46,16.46,0,0,0,749,951.377Z",
  transform: "translate(-689.862 -877.194)",
  fill: "#4d4c4c"
}), React.createElement("path", {
  id: "Path_210",
  "data-name": "Path 210",
  d: "M628.219,709.647l1.222,2.6-19.634,13.4-1.222-2.6Z",
  transform: "translate(-590.4 -709.528)",
  fill: "#373737"
}), React.createElement("path", {
  id: "Path_211",
  "data-name": "Path 211",
  d: "M581.014,722.613c-.288-.011-.572-.013-.854-.012-.112,0-.227,0-.339,0q-.568.012-1.121.059c-.085.007-.168.019-.253.027-.289.029-.575.063-.857.1-.107.016-.213.033-.319.052-.278.047-.551.1-.822.162-.078.017-.158.033-.236.051q-.5.122-.991.274c-.076.024-.15.051-.224.076q-.388.129-.765.277c-.086.034-.173.068-.259.1-.313.13-.622.268-.922.42l19.634-13.4.015-.008c.3-.149.6-.284.907-.412.086-.036.172-.07.259-.1.1-.041.2-.085.31-.124.15-.055.3-.1.456-.154.075-.025.148-.052.224-.075.3-.093.6-.179.9-.255l.091-.02c.078-.018.158-.034.236-.052.27-.06.544-.115.822-.162.106-.018.212-.036.319-.052.083-.013.165-.029.249-.04.2-.027.4-.044.608-.065.085-.008.168-.02.254-.027.342-.028.687-.049,1.038-.058h.083c.112,0,.226,0,.339,0,.282,0,.566,0,.854.012.146.006.294.016.442.024s.3.012.447.025q.293.024.59.056l-19.634,13.4c-.35-.038-.694-.06-1.036-.081C581.308,722.629,581.161,722.619,581.014,722.613Z",
  transform: "translate(-564.307 -709.199)",
  fill: "#4d4c4c"
}), React.createElement("path", {
  id: "Path_212",
  "data-name": "Path 212",
  d: "M755.938,932.447l19.635-13.4a22.989,22.989,0,0,1-.587,2.916l-19.634,13.4A22.9,22.9,0,0,0,755.938,932.447Z",
  transform: "translate(-698.174 -863.294)",
  fill: "#30302f"
}), React.createElement("path", {
  id: "Path_213",
  "data-name": "Path 213",
  d: "M615.16,733.174c-.158-.034-.316-.068-.472-.1s-.337-.061-.5-.09l-.253-.045q-.376-.059-.746-.107l19.634-13.4c.247.032.5.068.746.108.084.013.168.029.252.044.168.029.335.057.5.09l.051.009c.139.027.28.059.421.089l.241.051q.359.081.724.176l-19.635,13.4q-.364-.095-.723-.176C615.32,733.206,615.241,733.191,615.16,733.174Z",
  transform: "translate(-593.779 -716.713)",
  fill: "#30302f"
}), React.createElement("path", {
  id: "Path_214",
  "data-name": "Path 214",
  d: "M763.53,895.628c-.033-.5-.08-1.006-.135-1.513-.018-.165-.041-.331-.061-.5-.042-.344-.085-.689-.136-1.034-.028-.194-.06-.387-.09-.581q-.078-.485-.165-.973c-.036-.2-.072-.4-.111-.594-.089-.456-.179-.913-.282-1.371l19.634-13.4q.112.5.214,1.006c.024.122.044.244.068.366.039.2.075.4.111.593.059.325.113.65.166.974.031.193.061.386.09.579.05.347.095.692.135,1.036.02.166.043.331.061.5.055.506.1,1.011.135,1.513a32.75,32.75,0,0,1-.131,6.022L763.4,901.65A32.816,32.816,0,0,0,763.53,895.628Z",
  transform: "translate(-703.46 -831.437)",
  fill: "#4d4c4c"
}), React.createElement("g", {
  id: "Group_76",
  "data-name": "Group 76",
  transform: "translate(56.915 43.165)"
}, React.createElement("path", {
  id: "Path_215",
  "data-name": "Path 215",
  d: "M756.537,886.134l19.634-13.4L774,871.672l-19.634,13.4Z",
  transform: "translate(-754.362 -871.672)",
  fill: "#373737"
})), React.createElement("path", {
  id: "Path_216",
  "data-name": "Path 216",
  d: "M751.158,873.466c-.064-.237-.128-.474-.2-.712-.031-.108-.062-.216-.094-.324-.127-.434-.257-.868-.4-1.3l19.634-13.4c.139.435.269.869.4,1.3.016.055.035.11.05.164s.029.107.044.16q.1.356.2.711c.03.111.061.222.089.332.09.345.176.69.258,1.034l-19.634,13.4c-.081-.345-.168-.689-.258-1.034C751.219,873.687,751.188,873.576,751.158,873.466Z",
  transform: "translate(-694.591 -818.265)",
  fill: "#30302f"
}), React.createElement("path", {
  id: "Path_217",
  "data-name": "Path 217",
  d: "M686.769,742.463c1.037.733,2.057,1.524,3.058,2.356l-19.634,13.4c-1-.831-2.022-1.622-3.059-2.355Z",
  transform: "translate(-633.395 -733.625)",
  fill: "#30302f"
}), React.createElement("path", {
  id: "Path_218",
  "data-name": "Path 218",
  d: "M666.526,746.833l19.634-13.4.162,2.4-19.635,13.4Z",
  transform: "translate(-632.947 -726.993)",
  fill: "#373737"
}), React.createElement("path", {
  id: "Path_219",
  "data-name": "Path 219",
  d: "M627.3,727.2l-.128-.054c-.3-.124-.607-.242-.909-.355l-.232-.085q-.373-.136-.743-.261l-.2-.068c-.163-.054-.326-.105-.488-.156l-.242-.076q-.353-.108-.7-.205l-.018-.005h0l19.634-13.4q.36.1.723.21l.236.075c.164.051.329.1.494.158l.066.021.131.046c.247.084.495.171.745.262l.23.084c.3.113.6.23.909.354l.128.054c.268.11.538.226.809.346l.247.111c.311.141.624.286.939.439a44.219,44.219,0,0,1,5.739,3.392l-19.634,13.4a44.189,44.189,0,0,0-5.739-3.392c-.315-.154-.627-.3-.939-.439l-.247-.11C627.833,727.426,627.564,727.309,627.3,727.2Z",
  transform: "translate(-601.451 -711.647)",
  fill: "#4d4c4c"
}), React.createElement("path", {
  id: "Path_220",
  "data-name": "Path 220",
  d: "M717.363,806.543,737,793.141q.533.737,1.044,1.487c.025.037.048.075.073.112q.634.934,1.237,1.888l-19.634,13.4q-.6-.956-1.236-1.888C718.115,807.6,717.744,807.07,717.363,806.543Z",
  transform: "translate(-670.278 -770.839)",
  fill: "#30302f"
}), React.createElement("path", {
  id: "Path_221",
  "data-name": "Path 221",
  d: "M745.857,805.483l1.8-.283-19.634,13.4-1.8.283Z",
  transform: "translate(-676.784 -779.695)",
  fill: "#373737"
}), React.createElement("path", {
  id: "Path_222",
  "data-name": "Path 222",
  d: "M738.7,830.168q-.2-.53-.405-1.058c-.077-.2-.155-.393-.235-.589q-.239-.592-.493-1.18c-.055-.127-.107-.254-.163-.381q-.341-.779-.705-1.554c-.048-.1-.1-.206-.148-.309q-.3-.623-.608-1.242-.114-.228-.23-.454-.331-.648-.679-1.292c-.04-.075-.08-.151-.12-.227q-.39-.716-.8-1.423c-.359-.623-.724-1.242-1.1-1.856l19.634-13.4q.568.92,1.1,1.856c.031.052.064.1.094.156q.359.63.705,1.265c.042.077.081.154.122.231.163.3.326.6.483.906.066.127.129.255.194.381.078.153.155.3.231.457q.31.617.606,1.238c.05.1.1.208.15.313.017.035.035.07.052.106q.336.721.654,1.447c.056.128.108.256.164.384.116.27.234.54.346.811.051.122.1.245.146.367q.12.294.235.589.208.528.405,1.057c.072.192.144.384.213.577.034.095.072.189.105.284q.222.623.427,1.248h0l-19.634,13.4c-.168-.511-.348-1.023-.533-1.533C738.844,830.55,738.772,830.359,738.7,830.168Z",
  transform: "translate(-681.768 -779.695)",
  fill: "#4d4c4c"
}), React.createElement("path", {
  id: "Path_223",
  "data-name": "Path 223",
  d: "M691.168,768.281q-.44-.559-.889-1.108c-.14-.171-.281-.34-.423-.509q-.366-.438-.738-.869-.223-.257-.448-.513c-.229-.26-.46-.515-.692-.77-.2-.217-.4-.434-.6-.647-.226-.241-.453-.479-.682-.715-.2-.21-.4-.419-.607-.625-.184-.185-.37-.367-.555-.55q-.513-.5-1.033-.994-.275-.259-.552-.513c-.365-.335-.734-.663-1.1-.986-.215-.188-.428-.381-.646-.565l19.634-13.4.292.249c.119.1.235.212.354.316q.556.485,1.1.986c.185.17.369.341.553.515q.52.489,1.032.994c.11.109.224.212.334.322.074.075.147.152.221.227.2.206.406.416.609.625.228.237.456.474.681.715.2.213.4.43.595.647.135.148.272.291.4.44.1.109.192.221.289.331q.225.255.446.511.373.431.74.87c.141.169.282.337.422.508.066.081.134.159.2.24.232.287.46.578.689.868.065.082.131.163.2.246q.483.621.955,1.254l.176.238-19.634,13.4q-.556-.754-1.13-1.492C691.3,768.444,691.233,768.364,691.168,768.281Z",
  transform: "translate(-644.46 -735.867)",
  fill: "#4d4c4c"
}), React.createElement("g", {
  id: "Group_77",
  "data-name": "Group 77",
  transform: "translate(0 13.396)"
}, React.createElement("path", {
  id: "Path_224",
  "data-name": "Path 224",
  d: "M567.977,762.671a33.121,33.121,0,0,0-5.656-2.16l.162,2.4a23.2,23.2,0,0,0-2.938-.566l-1.222-2.6a16.692,16.692,0,0,0-9.44,1.489l1.228,2.611a12.57,12.57,0,0,0-2.027,1.352l-1.966-2.12a16.484,16.484,0,0,0-4.965,8.119l1.958,2.11a23.148,23.148,0,0,0-.587,2.917l-2.175-1.06a32.826,32.826,0,0,0-.131,6.022,43.922,43.922,0,0,0,.98,6.564l2.176,1.06c.289,1.232.639,2.47,1.033,3.706l-1.8.283a64.993,64.993,0,0,0,6.435,13.674l1.8-.283q1.12,1.777,2.354,3.484l-.947,1.554a65.188,65.188,0,0,0,10.291,11.1l.942-1.546q1.5,1.251,3.058,2.355l.162,2.4a44.584,44.584,0,0,0,5.739,3.39,33.381,33.381,0,0,0,5.656,2.163l-.162-2.4a22.849,22.849,0,0,0,2.938.566l1.224,2.6a16.7,16.7,0,0,0,9.441-1.486l-1.231-2.615a12.764,12.764,0,0,0,2.027-1.35l1.966,2.12a16.46,16.46,0,0,0,4.965-8.119l-1.958-2.113a22.9,22.9,0,0,0,.586-2.916l2.175,1.06a32.812,32.812,0,0,0,.13-6.022,43.907,43.907,0,0,0-.98-6.563l-2.175-1.06c-.289-1.231-.639-2.467-1.034-3.706l1.8-.281a64.976,64.976,0,0,0-6.435-13.673l-1.8.283q-1.12-1.782-2.354-3.487l.95-1.55a65.4,65.4,0,0,0-10.291-11.1l-.945,1.544c-1-.831-2.021-1.622-3.058-2.355l-.162-2.4A44.189,44.189,0,0,0,567.977,762.671Z",
  transform: "translate(-540.137 -759.619)",
  fill: "#373737"
})), React.createElement("path", {
  id: "Path_225",
  "data-name": "Path 225",
  d: "M718.312,800.707l19.634-13.4-.95,1.55-19.634,13.4Z",
  transform: "translate(-670.278 -766.555)",
  fill: "#373737"
}), React.createElement("g", {
  id: "Group_80",
  "data-name": "Group 80",
  transform: "translate(12.132 29.958)"
}, React.createElement("g", {
  id: "Group_78",
  "data-name": "Group 78"
}, React.createElement("path", {
  id: "Path_226",
  "data-name": "Path 226",
  d: "M601.43,823.692c8.764,4.27,16.462,15.174,17.9,25.01q.132.9.192,1.788c.694,10.27-6.282,14.922-15.581,10.391s-17.4-16.528-18.091-26.8q-.06-.887-.044-1.716C585.967,823.31,592.668,819.423,601.43,823.692Z",
  transform: "translate(-585.801 -821.958)",
  fill: "#bbbcbe"
})), React.createElement("g", {
  id: "Group_79",
  "data-name": "Group 79",
  transform: "translate(4.604 5.544)"
}, React.createElement("path", {
  id: "Path_227",
  "data-name": "Path 227",
  d: "M614.5,844.085c6.374,3.106,11.972,11.036,13.018,18.19.063.436.11.87.139,1.3.5,7.47-4.569,10.853-11.333,7.558s-12.653-12.02-13.157-19.49q-.044-.645-.032-1.248C603.252,843.808,608.126,840.981,614.5,844.085Z",
  transform: "translate(-603.132 -842.825)",
  fill: "#919396"
})), React.createElement("path", {
  id: "Path_228",
  "data-name": "Path 228",
  d: "M603.131,850.359c.1-5.458,3.462-8.33,8.236-7.39-3.644.167-6.072,2.935-6.154,7.559-.007.4,0,.818.032,1.248.5,7.47,6.4,16.2,13.157,19.49a12.868,12.868,0,0,0,3.141,1.085,10.9,10.9,0,0,1-5.222-1.253c-6.762-3.295-12.653-12.02-13.157-19.491C603.134,851.177,603.124,850.762,603.131,850.359Z",
  transform: "translate(-598.525 -837.257)",
  fill: "#d0d1d2"
})), React.createElement("g", {
  id: "Group_81",
  "data-name": "Group 81",
  transform: "translate(21.724 40.307)"
}, React.createElement("path", {
  id: "Path_229",
  "data-name": "Path 229",
  d: "M632.492,903.43a.9.9,0,0,0-.9-.027c-.472.315-.411,1.228.138,2.04a2.564,2.564,0,0,0,.952.873.9.9,0,0,0,.9.027c.472-.315.41-1.228-.137-2.04A2.569,2.569,0,0,0,632.492,903.43Z",
  transform: "translate(-628.789 -892.035)",
  fill: "#3a3e3f"
}), React.createElement("path", {
  id: "Path_230",
  "data-name": "Path 230",
  d: "M645.521,884.2c-1.639-.8-2.869.022-2.747,1.832a6.281,6.281,0,0,0,3.189,4.725c1.639.8,2.869-.021,2.747-1.833A6.282,6.282,0,0,0,645.521,884.2Z",
  transform: "translate(-637.224 -877.792)",
  fill: "#3a3e3f"
}), React.createElement("path", {
  id: "Path_231",
  "data-name": "Path 231",
  d: "M652.273,921.558c-.721-.352-1.263.01-1.209.806a2.767,2.767,0,0,0,1.4,2.078c.722.352,1.262-.01,1.209-.806A2.763,2.763,0,0,0,652.273,921.558Z",
  transform: "translate(-643.314 -905.347)",
  fill: "#3a3e3f"
}), React.createElement("path", {
  id: "Path_232",
  "data-name": "Path 232",
  d: "M670.871,922.129a.9.9,0,0,0-.895-.027c-.472.315-.411,1.228.138,2.04a2.557,2.557,0,0,0,.952.872.9.9,0,0,0,.9.027c.471-.315.409-1.228-.138-2.04A2.561,2.561,0,0,0,670.871,922.129Z",
  transform: "translate(-656.971 -905.766)",
  fill: "#3a3e3f"
}), React.createElement("path", {
  id: "Path_233",
  "data-name": "Path 233",
  d: "M629.632,861.046a.9.9,0,0,0-.9-.027c-.472.314-.411,1.228.138,2.039a2.55,2.55,0,0,0,.952.872.9.9,0,0,0,.9.028c.472-.314.41-1.228-.138-2.039A2.557,2.557,0,0,0,629.632,861.046Z",
  transform: "translate(-626.688 -860.912)",
  fill: "#3a3e3f"
}), React.createElement("path", {
  id: "Path_234",
  "data-name": "Path 234",
  d: "M648.423,864.5c.721.352,1.262-.01,1.208-.806a2.763,2.763,0,0,0-1.4-2.079c-.722-.352-1.262.01-1.209.806A2.763,2.763,0,0,0,648.423,864.5Z",
  transform: "translate(-640.344 -861.33)",
  fill: "#3a3e3f"
}), React.createElement("path", {
  id: "Path_235",
  "data-name": "Path 235",
  d: "M668.2,882.63a.9.9,0,0,0,.9.027c.471-.314.409-1.228-.138-2.039a2.56,2.56,0,0,0-.952-.872.9.9,0,0,0-.895-.028c-.472.314-.411,1.228.138,2.039A2.563,2.563,0,0,0,668.2,882.63Z",
  transform: "translate(-654.871 -874.643)",
  fill: "#3a3e3f"
}), React.createElement("path", {
  id: "Path_236",
  "data-name": "Path 236",
  d: "M624.519,880.444a2.764,2.764,0,0,0-1.4-2.079c-.721-.351-1.262.009-1.208.806a2.763,2.763,0,0,0,1.4,2.079C624.032,881.6,624.573,881.24,624.519,880.444Z",
  transform: "translate(-621.904 -873.629)",
  fill: "#3a3e3f"
}), React.createElement("path", {
  id: "Path_237",
  "data-name": "Path 237",
  d: "M677.388,904.81c-.721-.351-1.262.009-1.208.806a2.764,2.764,0,0,0,1.4,2.079c.722.351,1.262-.01,1.209-.807A2.763,2.763,0,0,0,677.388,904.81Z",
  transform: "translate(-661.757 -893.048)",
  fill: "#3a3e3f"
})), React.createElement("path", {
  id: "Path_238",
  "data-name": "Path 238",
  d: "M556.621,800.034c1.026,15.207,13.061,33.035,26.829,39.743a22.245,22.245,0,0,0,11.149,2.569,12.816,12.816,0,0,0,6.344-2.112c4.454-3,6.63-8.756,6.126-16.214-.059-.873-.155-1.769-.287-2.663a51.23,51.23,0,0,0-9.188-21.632c-4.923-6.907-11.086-12.393-17.354-15.447-6.557-3.2-12.618-3.454-17.066-.728-4.153,2.545-6.5,7.49-6.619,13.924h0C556.54,798.3,556.562,799.165,556.621,800.034Zm1.071-.072c-.056-.839-.078-1.671-.064-2.47h0c.108-6.054,2.277-10.68,6.106-13.027a11.88,11.88,0,0,1,5.434-1.677,21.2,21.2,0,0,1,10.6,2.455c12.675,6.176,23.832,21.768,25.95,36.269.127.867.22,1.735.278,2.58.476,7.06-1.532,12.475-5.654,15.25-4.153,2.795-9.985,2.606-16.423-.531C570.461,832.253,558.7,814.825,557.692,799.962Z",
  transform: "translate(-552.19 -762.421)",
  fill: "#4d4c4c"
})), React.createElement("path", {
  id: "Path_239",
  "data-name": "Path 239",
  d: "M969.487,530.36l-9.156,59.654a1.077,1.077,0,0,1-.045.188s0,.008,0,.011a.813.813,0,0,1-.067.146c0,.005-.006.011-.01.016a.637.637,0,0,1-.067.087c-.011.013-.021.029-.033.04a.62.62,0,0,1-.12.093l91.946-53.433a.611.611,0,0,0,.119-.093c.012-.012.022-.027.033-.04a.564.564,0,0,0,.061-.075l.007-.011.009-.017c.01-.018.021-.036.031-.056s.021-.047.031-.072l.006-.018s0-.007,0-.011l.012-.037c.006-.021.011-.042.017-.064s.009-.04.012-.061a.224.224,0,0,1,0-.025l9.156-59.654Z",
  transform: "translate(-310.049 -146.578)",
  fill: "#de9a27"
}), React.createElement("g", {
  id: "Group_87",
  "data-name": "Group 87",
  transform: "translate(824.863 475.29)"
}, React.createElement("g", {
  id: "Group_86",
  "data-name": "Group 86"
}, React.createElement("g", {
  id: "Group_83",
  "data-name": "Group 83",
  transform: "translate(12.829 7.407)"
}, React.createElement("path", {
  id: "Path_240",
  "data-name": "Path 240",
  d: "M1666.748,1052.477l3.641-2.116-.055,2.275-3.641,2.116Z",
  transform: "translate(-1666.693 -1050.361)",
  fill: "#242e39"
})), React.createElement("g", {
  id: "Group_84",
  "data-name": "Group 84",
  transform: "translate(0.056)"
}, React.createElement("path", {
  id: "Path_241",
  "data-name": "Path 241",
  d: "M1618.614,1024.6l3.641-2.116,12.829,7.407-3.641,2.116Z",
  transform: "translate(-1618.614 -1022.481)",
  fill: "#3d4956"
})), React.createElement("g", {
  id: "Group_85",
  "data-name": "Group 85",
  transform: "translate(0 2.116)"
}, React.createElement("path", {
  id: "Path_242",
  "data-name": "Path 242",
  d: "M1631.289,1037.854l-.055,2.275-12.829-7.407.056-2.275Z",
  transform: "translate(-1618.405 -1030.447)",
  fill: "#1a2027"
})))), React.createElement("g", {
  id: "Group_92",
  "data-name": "Group 92",
  transform: "translate(732.917 528.716)"
}, React.createElement("g", {
  id: "Group_91",
  "data-name": "Group 91",
  transform: "translate(0 0)"
}, React.createElement("g", {
  id: "Group_88",
  "data-name": "Group 88",
  transform: "translate(12.829 7.406)"
}, React.createElement("path", {
  id: "Path_243",
  "data-name": "Path 243",
  d: "M1320.663,1253.569l3.641-2.116-.055,2.276-3.641,2.116Z",
  transform: "translate(-1320.608 -1251.453)",
  fill: "#242e39"
})), React.createElement("g", {
  id: "Group_89",
  "data-name": "Group 89",
  transform: "translate(0.056)"
}, React.createElement("path", {
  id: "Path_244",
  "data-name": "Path 244",
  d: "M1272.53,1225.692l3.641-2.116,12.829,7.406-3.641,2.116Z",
  transform: "translate(-1272.53 -1223.576)",
  fill: "#3d4956"
})), React.createElement("g", {
  id: "Group_90",
  "data-name": "Group 90",
  transform: "translate(0 2.116)"
}, React.createElement("path", {
  id: "Path_245",
  "data-name": "Path 245",
  d: "M1285.2,1238.947l-.055,2.275-12.829-7.407.056-2.275Z",
  transform: "translate(-1272.32 -1231.541)",
  fill: "#323d48"
})))), React.createElement("g", {
  id: "Group_97",
  "data-name": "Group 97",
  transform: "translate(824.863 453.443)"
}, React.createElement("g", {
  id: "Group_96",
  "data-name": "Group 96",
  transform: "translate(0 0)"
}, React.createElement("g", {
  id: "Group_93",
  "data-name": "Group 93",
  transform: "translate(12.829 7.407)"
}, React.createElement("path", {
  id: "Path_246",
  "data-name": "Path 246",
  d: "M1666.748,970.244l3.641-2.116-.055,19.583-3.641,2.116Z",
  transform: "translate(-1666.693 -968.128)",
  fill: "#242e39"
})), React.createElement("g", {
  id: "Group_94",
  "data-name": "Group 94",
  transform: "translate(0.056)"
}, React.createElement("path", {
  id: "Path_247",
  "data-name": "Path 247",
  d: "M1618.614,942.365l3.641-2.116,12.829,7.407-3.641,2.116Z",
  transform: "translate(-1618.614 -940.249)",
  fill: "#3d4956"
})), React.createElement("g", {
  id: "Group_95",
  "data-name": "Group 95",
  transform: "translate(0 2.116)"
}, React.createElement("path", {
  id: "Path_248",
  "data-name": "Path 248",
  d: "M1631.289,955.621l-.055,19.583L1618.4,967.8l.056-19.584Z",
  transform: "translate(-1618.405 -948.214)",
  fill: "#1a2027"
})))), React.createElement("path", {
  id: "Path_249",
  "data-name": "Path 249",
  d: "M1172.984,630.725l86.848-50.47,9.5,31.385-86.848,50.471Z",
  transform: "translate(-466.459 -222.454)",
  fill: "#f6b918"
}), React.createElement("path", {
  id: "Path_250",
  "data-name": "Path 250",
  d: "M1038.344,552.99l86.848-50.47,35.771,20.652-86.848,50.471Z",
  transform: "translate(-367.589 -165.371)",
  fill: "#f8d260"
}), React.createElement("path", {
  id: "Path_251",
  "data-name": "Path 251",
  d: "M1315.373,834.54l86.848-50.47-.189,66.523-86.848,50.471Z",
  transform: "translate(-570.88 -372.12)",
  fill: "#de9a27"
}), React.createElement("path", {
  id: "Path_252",
  "data-name": "Path 252",
  d: "M1208.746,748.857l86.848-50.471,28.467,22.764-86.848,50.47Z",
  transform: "translate(-492.72 -309.201)",
  fill: "#f8d260"
}), React.createElement("path", {
  id: "Path_253",
  "data-name": "Path 253",
  d: "M1073.621,713.14l9.5,31.385,28.467,22.764-.188,66.523-16.561-9.562-15.406-44.712-41.762-24.112.179-62.939Z",
  transform: "translate(-367.096 -304.869)",
  fill: "#f6b11c"
}), React.createElement("g", {
  id: "Group_102",
  "data-name": "Group 102",
  transform: "translate(661.432 447.976)"
}, React.createElement("g", {
  id: "Group_101",
  "data-name": "Group 101",
  transform: "translate(0 0)"
}, React.createElement("g", {
  id: "Group_98",
  "data-name": "Group 98",
  transform: "translate(48.623 28.06)"
}, React.createElement("path", {
  id: "Path_254",
  "data-name": "Path 254",
  d: "M1186.271,1029.31l6.916-4.019,9.981,36.952-6.916,4.019Z",
  transform: "translate(-1186.271 -1025.291)",
  fill: "#f8d260"
})), React.createElement("g", {
  id: "Group_99",
  "data-name": "Group 99",
  transform: "translate(0.023)"
}, React.createElement("path", {
  id: "Path_255",
  "data-name": "Path 255",
  d: "M1003.343,923.691l6.916-4.019,48.6,28.06-6.916,4.019Z",
  transform: "translate(-1003.343 -919.673)",
  fill: "#fae361"
})), React.createElement("g", {
  id: "Group_100",
  "data-name": "Group 100",
  transform: "translate(0 4.019)"
}, React.createElement("path", {
  id: "Path_256",
  "data-name": "Path 256",
  d: "M1051.878,962.86l9.981,36.952-7.8-4.5-7.923-27.467-42.88-24.758.023-8.285Z",
  transform: "translate(-1003.255 -934.799)",
  fill: "#f9db40"
})))), React.createElement("path", {
  id: "Path_257",
  "data-name": "Path 257",
  d: "M1334.373,1027.4l88.3-51.309-.055,19.583-88.3,51.309Z",
  transform: "translate(-584.93 -513.128)",
  fill: "#242e39"
}), React.createElement("path", {
  id: "Path_258",
  "data-name": "Path 258",
  d: "M1314.523,1015.823l88.3-51.309,5.314,3.077-88.3,51.309Z",
  transform: "translate(-570.394 -504.624)",
  fill: "#3d4956"
}), React.createElement("g", {
  id: "Group_107",
  "data-name": "Group 107",
  transform: "translate(732.917 506.869)"
}, React.createElement("g", {
  id: "Group_106",
  "data-name": "Group 106"
}, React.createElement("g", {
  id: "Group_103",
  "data-name": "Group 103",
  transform: "translate(12.829 7.407)"
}, React.createElement("path", {
  id: "Path_259",
  "data-name": "Path 259",
  d: "M1320.663,1171.338l3.641-2.116-.055,19.583-3.641,2.116Z",
  transform: "translate(-1320.608 -1169.222)",
  fill: "#242e39"
})), React.createElement("g", {
  id: "Group_104",
  "data-name": "Group 104",
  transform: "translate(0.056)"
}, React.createElement("path", {
  id: "Path_260",
  "data-name": "Path 260",
  d: "M1272.53,1143.459l3.641-2.116L1289,1148.75l-3.641,2.116Z",
  transform: "translate(-1272.53 -1141.342)",
  fill: "#3d4956"
})), React.createElement("g", {
  id: "Group_105",
  "data-name": "Group 105",
  transform: "translate(0 2.116)"
}, React.createElement("path", {
  id: "Path_261",
  "data-name": "Path 261",
  d: "M1285.2,1156.715l-.055,19.583-12.829-7.406.056-19.583Z",
  transform: "translate(-1272.32 -1149.308)",
  fill: "#323d48"
})))), React.createElement("g", {
  id: "Group_108",
  "data-name": "Group 108",
  transform: "translate(748.932 491.592)"
}, React.createElement("path", {
  id: "Path_262",
  "data-name": "Path 262",
  d: "M1337.688,1084.326a10.1,10.1,0,0,0-5.02,7.015q-.037.253-.054.5c-.195,2.881,1.762,4.185,4.37,2.915a9.993,9.993,0,0,0,5.074-7.517c.012-.165.015-.326.012-.481C1342.025,1084.218,1340.146,1083.128,1337.688,1084.326Z",
  transform: "translate(-1332.601 -1083.839)",
  fill: "#e7e6e6"
})), React.createElement("g", {
  id: "Group_109",
  "data-name": "Group 109",
  transform: "translate(817.389 451.818)"
}, React.createElement("path", {
  id: "Path_263",
  "data-name": "Path 263",
  d: "M1595.36,934.618a10.1,10.1,0,0,0-5.021,7.015q-.037.253-.054.5c-.194,2.88,1.762,4.185,4.371,2.914a9.991,9.991,0,0,0,5.073-7.516c.012-.166.015-.326.013-.481C1599.7,934.511,1597.818,933.42,1595.36,934.618Z",
  transform: "translate(-1590.272 -934.131)",
  fill: "#e7e6e6"
})), React.createElement("g", {
  id: "Group_110",
  "data-name": "Group 110",
  transform: "translate(741.208 484.644)"
}, React.createElement("path", {
  id: "Path_264",
  "data-name": "Path 264",
  d: "M1306.813,1059.329l-.011,4.04-2.7-1.561a1.255,1.255,0,0,1-.57-.988l.007-2.725c0-.364.258-.51.574-.327Z",
  transform: "translate(-1303.527 -1057.689)",
  fill: "#414141"
})), React.createElement("g", {
  id: "Group_111",
  "data-name": "Group 111",
  transform: "translate(741.208 490.323)"
}, React.createElement("path", {
  id: "Path_265",
  "data-name": "Path 265",
  d: "M1306.813,1080.706l-.011,4.039-2.7-1.561a1.255,1.255,0,0,1-.57-.988l.007-2.724c0-.364.258-.51.574-.327Z",
  transform: "translate(-1303.527 -1079.066)",
  fill: "#414141"
})), React.createElement("g", {
  id: "Group_112",
  "data-name": "Group 112",
  transform: "translate(744.235 467.607)"
}, React.createElement("path", {
  id: "Path_266",
  "data-name": "Path 266",
  d: "M1314.922,995.2l.011,4.04,2.7-1.561a1.254,1.254,0,0,0,.571-.988l-.008-2.724c0-.364-.258-.51-.574-.327Z",
  transform: "translate(-1314.922 -993.56)",
  fill: "#414141"
})), React.createElement("g", {
  id: "Group_113",
  "data-name": "Group 113",
  transform: "translate(744.235 473.286)"
}, React.createElement("path", {
  id: "Path_267",
  "data-name": "Path 267",
  d: "M1314.922,1016.576l.011,4.04,2.7-1.561a1.256,1.256,0,0,0,.571-.989l-.008-2.724c0-.364-.258-.51-.574-.327Z",
  transform: "translate(-1314.922 -1014.936)",
  fill: "#414141"
})), React.createElement("g", {
  id: "Group_114",
  "data-name": "Group 114",
  transform: "translate(744.235 478.965)"
}, React.createElement("path", {
  id: "Path_268",
  "data-name": "Path 268",
  d: "M1314.922,1037.953l.011,4.04,2.7-1.561a1.256,1.256,0,0,0,.571-.988l-.008-2.724c0-.364-.258-.51-.574-.327Z",
  transform: "translate(-1314.922 -1036.313)",
  fill: "#414141"
})), React.createElement("g", {
  id: "Group_115",
  "data-name": "Group 115",
  transform: "translate(744.235 484.644)"
}, React.createElement("path", {
  id: "Path_269",
  "data-name": "Path 269",
  d: "M1314.922,1059.329l.011,4.04,2.7-1.561a1.255,1.255,0,0,0,.571-.988l-.008-2.725c0-.364-.258-.51-.574-.327Z",
  transform: "translate(-1314.922 -1057.689)",
  fill: "#414141"
})), React.createElement("g", {
  id: "Group_116",
  "data-name": "Group 116",
  transform: "translate(744.235 490.323)"
}, React.createElement("path", {
  id: "Path_270",
  "data-name": "Path 270",
  d: "M1314.922,1080.706l.011,4.039,2.7-1.561a1.255,1.255,0,0,0,.571-.988l-.008-2.724c0-.364-.258-.51-.574-.327Z",
  transform: "translate(-1314.922 -1079.066)",
  fill: "#414141"
})), React.createElement("path", {
  id: "Path_271",
  "data-name": "Path 271",
  d: "M1069.922,722.274l-.04,14.365-10.476-6.048.041-14.365Z",
  transform: "translate(-383.056 -322.301)",
  fill: "#34262c"
}), React.createElement("path", {
  id: "Path_272",
  "data-name": "Path 272",
  d: "M1123.275,753.046l7.17,24.642-22.359-12.909.021-20.491Z",
  transform: "translate(-418.802 -342.908)",
  fill: "#34262c"
}), React.createElement("path", {
  id: "Path_273",
  "data-name": "Path 273",
  d: "M1268.861,599.215l-80.88,47,7.5,24.778,80.88-47Z",
  transform: "translate(-477.471 -236.377)",
  fill: "#3c3338"
}), React.createElement("path", {
  id: "Path_274",
  "data-name": "Path 274",
  d: "M1390.25,889.478l48-27.893-.1,34.106-48,27.894Z",
  transform: "translate(-625.926 -429.041)",
  fill: "#373737"
}), React.createElement("path", {
  id: "Path_275",
  "data-name": "Path 275",
  d: "M1378.846,964.176,1432,933.285l-.115,3.653-53.155,30.89Z",
  transform: "translate(-617.543 -481.693)",
  fill: "#de9a27"
}), React.createElement("path", {
  id: "Path_276",
  "data-name": "Path 276",
  d: "M1067.3,920.91l-.79-.458v0l-42.573-24.6s-1.179-.164-1.179.9v8.719a1.784,1.784,0,0,0,2.357,0v-6.243l40.449,23.379v7.774l.043.025a2.231,2.231,0,0,0,2.351-.025v-8.323A1.323,1.323,0,0,0,1067.3,920.91Z",
  transform: "translate(-356.144 -454.194)",
  fill: "#151517"
}), React.createElement("path", {
  id: "Path_277",
  "data-name": "Path 277",
  d: "M1299.984,1185.326v9.648l5.507,3.2.027-9.646Z",
  transform: "translate(-559.717 -666.772)",
  fill: "#e7e6e6"
}), React.createElement("path", {
  id: "Path_278",
  "data-name": "Path 278",
  d: "M1302.751,1186.928l-2.767-1.6v9.648l2.767,1.608Z",
  transform: "translate(-559.717 -666.772)",
  fill: "#faae40"
}), React.createElement("path", {
  id: "Path_279",
  "data-name": "Path 279",
  d: "M1320.608,1192.922l2.767-1.6v9.647l-2.767,1.609Z",
  transform: "translate(-574.862 -671.174)",
  fill: "#e7e6e6"
}), React.createElement("path", {
  id: "Path_280",
  "data-name": "Path 280",
  d: "M1670.19,988.411l2.767-1.6v9.647l-2.767,1.609Z",
  transform: "translate(-831.569 -520.997)",
  fill: "#e7e6e6"
}), React.createElement("path", {
  id: "Path_281",
  "data-name": "Path 281",
  d: "M1632.807,811.881a.876.876,0,0,0-.437.758v2.7a.507.507,0,0,0,.762.438l2.006-1.166v-4.081Z",
  transform: "translate(-803.796 -391.552)",
  fill: "#414141"
}), React.createElement("path", {
  id: "Path_282",
  "data-name": "Path 282",
  d: "M1632.807,833.6a.876.876,0,0,0-.437.759v2.7a.507.507,0,0,0,.762.439l2.006-1.166v-4.081Z",
  transform: "translate(-803.796 -407.498)",
  fill: "#414141"
}), React.createElement("path", {
  id: "Path_283",
  "data-name": "Path 283",
  d: "M1632.807,855.314a.876.876,0,0,0-.437.759v2.7a.507.507,0,0,0,.762.438l2.006-1.166v-4.08Z",
  transform: "translate(-803.796 -423.447)",
  fill: "#414141"
}), React.createElement("path", {
  id: "Path_284",
  "data-name": "Path 284",
  d: "M1632.807,877.03a.876.876,0,0,0-.437.759v2.7a.507.507,0,0,0,.762.438l2.006-1.166v-4.08Z",
  transform: "translate(-803.796 -439.393)",
  fill: "#414141"
}), React.createElement("path", {
  id: "Path_285",
  "data-name": "Path 285",
  d: "M1632.807,898.746a.876.876,0,0,0-.437.759v2.7a.507.507,0,0,0,.762.439l2.006-1.166V897.4Z",
  transform: "translate(-803.796 -455.339)",
  fill: "#414141"
}), React.createElement("g", {
  id: "Group_117",
  "data-name": "Group 117",
  transform: "translate(778.17 481.045)"
}, React.createElement("path", {
  id: "Path_286",
  "data-name": "Path 286",
  d: "M1442.651,1108.154l33.67-19.561.966.559-34.636,20.129Z",
  transform: "translate(-1442.651 -1076.784)",
  fill: "#3d4956"
}), React.createElement("path", {
  id: "Path_287",
  "data-name": "Path 287",
  d: "M1476.324,1057.494v-11.252l-33.67,19.534v11.279Z",
  transform: "translate(-1442.653 -1045.685)",
  fill: "#1a2027"
}), React.createElement("path", {
  id: "Path_288",
  "data-name": "Path 288",
  d: "M1570.353,1044.144v12.368l-.966-.559V1044.7Z",
  transform: "translate(-1535.716 -1044.144)",
  fill: "#3d4956"
})), React.createElement("g", {
  id: "Group_121",
  "data-name": "Group 121",
  transform: "translate(537.761 277.317)"
}, React.createElement("g", {
  id: "Group_118",
  "data-name": "Group 118",
  transform: "translate(5.718)"
}, React.createElement("path", {
  id: "Path_289",
  "data-name": "Path 289",
  d: "M652.075,277.466l-.051-.026-.031-.015-.008,0-.011-.005-.05-.021-.05-.019-.006,0-.006,0-.039-.012a.491.491,0,0,0-.051-.014l-.02,0-.012,0-.02,0-.054-.009-.028,0h-.028c-.02,0-.04,0-.06,0h-.063l-.071.01a.628.628,0,0,0-.087.024h0a.71.71,0,0,0-.1.044h0l-91.946,53.433a.588.588,0,0,1,.1-.044.653.653,0,0,1,.092-.026h0a.75.75,0,0,1,.095-.011h.019a.889.889,0,0,1,.1,0h.013a.947.947,0,0,1,.1.016l.011,0c.036.009.072.018.109.031l.006,0c.039.014.078.03.117.047l.009,0c.04.019.08.04.12.063l91.946-53.433Z",
  transform: "translate(-559.284 -277.317)",
  fill: "#f8d260"
}), React.createElement("path", {
  id: "Path_290",
  "data-name": "Path 290",
  d: "M654.561,277.959l-91.946,53.433,86.937,50.191,91.866-53.511Z",
  transform: "translate(-561.73 -277.788)",
  fill: "#f8d260"
})), React.createElement("path", {
  id: "Path_291",
  "data-name": "Path 291",
  d: "M1185.331,511.561l-91.946,53.433-2.17,3.556h0a.716.716,0,0,1-.07.09c-.012.013-.021.029-.033.041a.6.6,0,0,1-.12.092l91.946-53.433a.614.614,0,0,0,.12-.092c.012-.012.022-.028.033-.041a.674.674,0,0,0,.063-.077l.007-.012h0Z",
  transform: "translate(-944.012 -449.328)",
  fill: "#f1a71f"
}), React.createElement("g", {
  id: "Group_119",
  "data-name": "Group 119",
  transform: "translate(112.363 39.032)"
}, React.createElement("path", {
  id: "Path_292",
  "data-name": "Path 292",
  d: "M960.693,477.756l92.38-53.524,35.476,20.482L996.6,498.148Z",
  transform: "translate(-960.693 -424.233)",
  fill: "#f6b918"
})), React.createElement("g", {
  id: "Group_120",
  "data-name": "Group 120",
  transform: "translate(0 53.433)"
}, React.createElement("path", {
  id: "Path_293",
  "data-name": "Path 293",
  d: "M686.035,537.952c.93.537,1.528,2.015,1.1,2.719l-2.169,3.556c-.214.351-.64.4-1.105.136l-23.19-13.388c-.61-.353-1.133-.144-1.23.495l-9.157,59.654c-.1.638-.62.847-1.23.495L598.34,562.34a2.263,2.263,0,0,1-.6-.522L538.4,489.99a2.172,2.172,0,0,1-.506-2.191l5.355-9.048c.213-.359.642-.415,1.113-.144l86.022,49.665a.88.88,0,0,0,.89.083l18.848-10.8c.235-.14.668.045,1,.238Z",
  transform: "translate(-537.761 -478.437)",
  fill: "#fac813"
})), React.createElement("path", {
  id: "Path_294",
  "data-name": "Path 294",
  d: "M1189.043,503.535c0-.019,0-.038,0-.057s0-.039,0-.058,0-.011,0-.017v-.009c0-.011,0-.022,0-.033s0-.04,0-.059,0-.04-.007-.06l0-.026s0-.007,0-.01,0-.018,0-.027-.007-.042-.011-.063-.008-.044-.013-.066,0-.018-.006-.028l0-.011-.006-.027-.018-.066c-.006-.022-.013-.044-.019-.067l-.008-.025a.071.071,0,0,0,0-.011c0-.01-.006-.02-.009-.03l-.022-.064c-.007-.021-.015-.042-.024-.062l-.012-.031,0-.01-.009-.022-.026-.061-.027-.06-.021-.042-.005-.011-.008-.017-.037-.071c-.013-.025-.028-.049-.042-.074l-.02-.035-.01-.018c-.023-.038-.047-.076-.071-.113-.005-.009-.012-.018-.018-.026l-.029-.041-.04-.058-.055-.073-.012-.015-.008-.01-.029-.035-.047-.055-.048-.053-.01-.011-.007-.007-.033-.035-.051-.051-.054-.05-.007-.006-.005,0-.043-.038c-.017-.015-.036-.03-.054-.044l-.055-.042,0,0,0,0-.047-.033-.054-.036-.054-.033-.013-.008-91.946,53.433a1.778,1.778,0,0,1,.168.11l0,0a1.988,1.988,0,0,1,.157.127l.006,0c.05.045.1.093.146.142l0,0c.048.052.093.1.135.157a.048.048,0,0,1,.007.01c.038.047.073.1.108.145l.029.041c.035.052.068.1.1.157l.02.035c.031.053.06.107.087.162l.005.011c.029.061.057.122.082.184l0,.009c.025.063.048.124.068.187a.053.053,0,0,0,0,.011c.02.062.037.124.051.185l0,.012c.014.061.026.122.034.183,0,0,0,.007,0,.011.008.06.014.119.016.178v.009a1.585,1.585,0,0,1,0,.172v0a1.376,1.376,0,0,1-.023.163l0,.01a1.043,1.043,0,0,1-.044.15.011.011,0,0,1,0,0,.963.963,0,0,1-.067.138l91.946-53.433c.013-.023.027-.047.038-.071s.019-.043.028-.066l0,0v0c.009-.023.017-.046.024-.069s.011-.041.016-.062c0-.005,0-.011,0-.017l0-.01.007-.033c0-.019.007-.039.009-.059s0-.038.005-.057c0,0,0-.007,0-.011v0C1189.041,503.562,1189.042,503.549,1189.043,503.535Z",
  transform: "translate(-947.584 -441.813)",
  fill: "#f8d260"
})), React.createElement("g", {
  id: "Group_122",
  "data-name": "Group 122",
  transform: "translate(549.8 343.212)"
}, React.createElement("path", {
  id: "Path_295",
  "data-name": "Path 295",
  d: "M677.286,578.982a2.47,2.47,0,0,1,1.138,2.2l-4.46,29.049c-.091.595-.576.79-1.144.462L632.67,587.51a2.106,2.106,0,0,1-.555-.485l-48.443-58.637a2.022,2.022,0,0,1-.471-2.04l.42-.714c.2-.333.6-.384,1.036-.132l76.666,44.263L664,571.313Z",
  transform: "translate(-583.074 -525.344)",
  fill: "#f6b11c"
})), React.createElement("path", {
  id: "Path_296",
  "data-name": "Path 296",
  d: "M610.043,350.538l79.272-46.154,81,46.539L690.546,397Z",
  transform: "translate(-53.079 -19.876)",
  fill: "#de9a27"
}), React.createElement("path", {
  id: "Path_297",
  "data-name": "Path 297",
  d: "M635.124,585.327a2.115,2.115,0,0,1-.555-.485l-48.214-58.359-1.7-.981c-.438-.252-.838-.2-1.036.132l-.42.714a2.022,2.022,0,0,0,.471,2.04l48.443,58.637a2.109,2.109,0,0,0,.555.485l40.149,23.18c.568.329,1.054.133,1.144-.462l.349-2.275Z",
  transform: "translate(-33.274 -182.132)",
  fill: "#f8d260"
}), React.createElement("path", {
  id: "Path_298",
  "data-name": "Path 298",
  d: "M620.339,360.168l77.767,44.882,79.774-46.075c.136-.079-6.172-7.158-6.563-7.539-2.439-2.376-5.172-4.25-7.786-6.385-2.589-2.114-4.446-5.752-6.393-8.514a15.163,15.163,0,0,1-2.627-4.923,15.547,15.547,0,0,0-.513-2.086c-.838-2.087-3.37-3.319-5.288-4.24-3.768-1.809-7.353-4.475-11.446-5.463a61.973,61.973,0,0,0-8.28-.909c-4.945-.506-9.727-2-14.585-3.051-3.817-.827-6.8-.75-10.307.9a60.684,60.684,0,0,1-9.688,3.326c-11.469,3.146-15.355,2.177-29.158,8.267C665.246,328.353,635.3,338.17,620.339,360.168Z",
  transform: "translate(-60.639 -27.927)",
  fill: "#27343c"
}), React.createElement("path", {
  id: "Path_299",
  "data-name": "Path 299",
  d: "M979.339,394.616l1.808-.947s1.421-.129,1.981.474a12.188,12.188,0,0,1,1.292,1.636,1.339,1.339,0,0,1-.431.99,4.493,4.493,0,0,1-.861.345c-.258.086-2.841.345-2.841.345S978.306,396.123,979.339,394.616Z",
  transform: "translate(-324.042 -85.431)",
  fill: "#3d4956"
}), React.createElement("path", {
  id: "Path_300",
  "data-name": "Path 300",
  d: "M1118.527,443l1.808-.947s1.421-.129,1.98.474a12.09,12.09,0,0,1,1.292,1.636,1.341,1.341,0,0,1-.431.99,4.5,4.5,0,0,1-.861.345c-.258.086-2.842.344-2.842.344S1117.494,444.508,1118.527,443Z",
  transform: "translate(-426.25 -120.962)",
  fill: "#3d4956"
}), React.createElement("path", {
  id: "Path_301",
  "data-name": "Path 301",
  d: "M892.719,372l1.808-.947s1.421-.129,1.981.474a12.085,12.085,0,0,1,1.292,1.636,1.337,1.337,0,0,1-.43.99,4.488,4.488,0,0,1-.861.345c-.259.086-2.842.345-2.842.345S891.686,373.511,892.719,372Z",
  transform: "translate(-260.435 -68.827)",
  fill: "#3d4956"
}), React.createElement("path", {
  id: "Path_302",
  "data-name": "Path 302",
  d: "M932.188,574.061l1.808-.947s1.421-.129,1.981.474a12.128,12.128,0,0,1,1.291,1.636,1.339,1.339,0,0,1-.43.99,4.505,4.505,0,0,1-.861.344c-.258.086-2.842.345-2.842.345S931.155,575.568,932.188,574.061Z",
  transform: "translate(-289.417 -217.202)",
  fill: "#3d4956"
}), React.createElement("path", {
  id: "Path_303",
  "data-name": "Path 303",
  d: "M1017.427,383.734s1.841-.42,2.422.161a12.713,12.713,0,0,1,1.421,2.164s.161,1.818-.291,2.1-1.615-.651-2-.876-1.808-1.227-1.808-1.227S1016.1,384.38,1017.427,383.734Z",
  transform: "translate(-351.742 -78.037)",
  fill: "#3d4956"
}), React.createElement("path", {
  id: "Path_304",
  "data-name": "Path 304",
  d: "M1034.492,487.158s1.841-.42,2.422.161a12.691,12.691,0,0,1,1.421,2.164s.161,1.819-.291,2.1-1.615-.651-2-.877-1.808-1.227-1.808-1.227S1033.169,487.8,1034.492,487.158Z",
  transform: "translate(-364.274 -153.983)",
  fill: "#3d4956"
}), React.createElement("path", {
  id: "Path_305",
  "data-name": "Path 305",
  d: "M860.261,473.8s.421-1.84,1.2-2.112a12.721,12.721,0,0,1,2.566-.34s1.708.644,1.769,1.176-1.288,1.171-1.66,1.423-1.89,1.1-1.89,1.1S860.268,475.272,860.261,473.8Z",
  transform: "translate(-236.819 -142.481)",
  fill: "#3d4956"
}), React.createElement("path", {
  id: "Path_306",
  "data-name": "Path 306",
  d: "M707.321,445.472s1.3-1.37,2.1-1.209a12.689,12.689,0,0,1,2.382,1.012s1.143,1.423.925,1.912-1.7.354-2.152.382-2.185-.018-2.185-.018S706.578,446.744,707.321,445.472Z",
  transform: "translate(-124.381 -122.583)",
  fill: "#3d4956"
}), React.createElement("path", {
  id: "Path_307",
  "data-name": "Path 307",
  d: "M753.357,430.96a2.238,2.238,0,0,1,1.046-.232c.465.058.581.7.581.7l-.407.523-.988.291S752.8,431.156,753.357,430.96Z",
  transform: "translate(-158.171 -112.647)",
  fill: "#3d4956"
}), React.createElement("path", {
  id: "Path_308",
  "data-name": "Path 308",
  d: "M743.958,449.435A2.234,2.234,0,0,1,745,449.2c.465.058.581.7.581.7l-.407.523-.988.29S743.4,449.63,743.958,449.435Z",
  transform: "translate(-151.269 -126.214)",
  fill: "#3d4956"
}), React.createElement("path", {
  id: "Path_309",
  "data-name": "Path 309",
  d: "M1010.086,411.773a2.229,2.229,0,0,1,1.046-.233c.465.058.581.7.581.7l-.407.523-.988.291S1009.528,411.969,1010.086,411.773Z",
  transform: "translate(-346.693 -98.558)",
  fill: "#3d4956"
}), React.createElement("path", {
  id: "Path_310",
  "data-name": "Path 310",
  d: "M963.871,371.286a2.231,2.231,0,0,1,1.047-.232c.465.058.581.7.581.7l-.407.523-.988.291S963.313,371.481,963.871,371.286Z",
  transform: "translate(-312.756 -68.827)",
  fill: "#3d4956"
}), React.createElement("path", {
  id: "Path_311",
  "data-name": "Path 311",
  d: "M956.747,342.615a2.232,2.232,0,0,1,1.046-.232c.465.058.581.7.581.7l-.407.523-.988.291S956.188,342.81,956.747,342.615Z",
  transform: "translate(-307.524 -47.774)",
  fill: "#3d4956"
}), React.createElement("path", {
  id: "Path_312",
  "data-name": "Path 312",
  d: "M1082.837,358.821a2.225,2.225,0,0,1,1.046-.232c.465.058.581.7.581.7l-.406.523-.988.291S1082.278,359.016,1082.837,358.821Z",
  transform: "translate(-400.115 -59.674)",
  fill: "#3d4956"
}), React.createElement("path", {
  id: "Path_313",
  "data-name": "Path 313",
  d: "M1047.66,353.1a2.236,2.236,0,0,1,1.046-.233c.465.058.581.7.581.7l-.407.523-.988.291S1047.1,353.3,1047.66,353.1Z",
  transform: "translate(-374.284 -55.475)",
  fill: "#3d4956"
}), React.createElement("path", {
  id: "Path_314",
  "data-name": "Path 314",
  d: "M1097.289,457.01a2.236,2.236,0,0,1,1.046-.233c.464.059.581.7.581.7l-.406.523-.989.291S1096.73,457.205,1097.289,457.01Z",
  transform: "translate(-410.727 -131.776)",
  fill: "#3d4956"
}), React.createElement("path", {
  id: "Path_315",
  "data-name": "Path 315",
  d: "M1079.4,405.344a2.233,2.233,0,0,1,1.046-.232c.465.058.582.7.582.7l-.407.523-.988.291S1078.84,405.539,1079.4,405.344Z",
  transform: "translate(-397.59 -93.837)",
  fill: "#3d4956"
}), React.createElement("path", {
  id: "Path_316",
  "data-name": "Path 316",
  d: "M1147.669,481.547a2.241,2.241,0,0,1,1.047-.232c.465.058.581.7.581.7l-.407.523-.988.291S1147.111,481.742,1147.669,481.547Z",
  transform: "translate(-447.723 -149.794)",
  fill: "#3d4956"
}), React.createElement("path", {
  id: "Path_317",
  "data-name": "Path 317",
  d: "M895.879,577.637a2.231,2.231,0,0,1,1.046-.233c.465.058.581.7.581.7l-.407.523-.989.291S895.32,577.832,895.879,577.637Z",
  transform: "translate(-262.827 -220.355)",
  fill: "#3d4956"
}), React.createElement("path", {
  id: "Path_318",
  "data-name": "Path 318",
  d: "M668.489,464.3a2.232,2.232,0,0,1,1.046-.232c.465.058.581.7.581.7l-.406.523-.988.291S667.93,464.5,668.489,464.3Z",
  transform: "translate(-95.85 -137.13)",
  fill: "#3d4956"
}), React.createElement("path", {
  id: "Path_319",
  "data-name": "Path 319",
  d: "M1279.645,777.394l58.475-33.982,19.167,15.328-58.475,33.982Z",
  transform: "translate(-544.783 -342.264)",
  fill: "#f6b918"
}), React.createElement("path", {
  id: "Path_320",
  "data-name": "Path 320",
  d: "M1037.874,845.5l73.83,42.828.013-4.352-73.83-42.829Z",
  transform: "translate(-367.244 -414.034)",
  fill: "#ee7526"
}), React.createElement("path", {
  id: "Path_321",
  "data-name": "Path 321",
  d: "M1037.795,873.683l73.83,42.829.013-4.352-73.83-42.829Z",
  transform: "translate(-367.186 -434.729)",
  fill: "#ee7526"
}), React.createElement("g", {
  id: "Group_123",
  "data-name": "Group 123",
  transform: "translate(741.208 467.607)"
}, React.createElement("path", {
  id: "Path_322",
  "data-name": "Path 322",
  d: "M1306.813,995.2l-.011,4.04-2.7-1.561a1.254,1.254,0,0,1-.57-.988l.007-2.724c0-.364.258-.51.574-.327Z",
  transform: "translate(-1303.527 -993.56)",
  fill: "#414141"
})), React.createElement("g", {
  id: "Group_124",
  "data-name": "Group 124",
  transform: "translate(741.208 473.286)"
}, React.createElement("path", {
  id: "Path_323",
  "data-name": "Path 323",
  d: "M1306.813,1016.576l-.011,4.04-2.7-1.561a1.256,1.256,0,0,1-.57-.989l.007-2.724c0-.364.258-.51.574-.327Z",
  transform: "translate(-1303.527 -1014.936)",
  fill: "#414141"
})), React.createElement("g", {
  id: "Group_125",
  "data-name": "Group 125",
  transform: "translate(741.208 478.965)"
}, React.createElement("path", {
  id: "Path_324",
  "data-name": "Path 324",
  d: "M1306.813,1037.953l-.011,4.04-2.7-1.561a1.256,1.256,0,0,1-.57-.988l.007-2.724c0-.364.258-.51.574-.327Z",
  transform: "translate(-1303.527 -1036.313)",
  fill: "#414141"
})), React.createElement("path", {
  id: "Path_325",
  "data-name": "Path 325",
  d: "M1107.848,821.4l-.084,29.7,22.726,13.121.084-29.7Zm21.911,41.554L1108.5,850.684l.08-28.016,21.258,12.274Z",
  transform: "translate(-418.566 -399.535)",
  fill: "#414141",
  opacity: 0.21
}), React.createElement("g", {
  id: "Group_126",
  "data-name": "Group 126",
  transform: "translate(706.161 415.052)"
}, React.createElement("path", {
  id: "Path_326",
  "data-name": "Path 326",
  d: "M1184.078,798.817l-7,4.069-.054,15.353,7-4.069Z",
  transform: "translate(-1175.586 -798.002)",
  fill: "#30302f"
}), React.createElement("path", {
  id: "Path_327",
  "data-name": "Path 327",
  d: "M1184.078,865.458l-7,4.069-.054,8.986,7-4.069Z",
  transform: "translate(-1175.586 -846.938)",
  fill: "#30302f"
}), React.createElement("path", {
  id: "Path_328",
  "data-name": "Path 328",
  d: "M1171.817,799.817l1.437.816,7-4.069-1.437-.815Z",
  transform: "translate(-1171.763 -795.748)",
  fill: "#4d4c4c"
}), React.createElement("path", {
  id: "Path_329",
  "data-name": "Path 329",
  d: "M1171.668,811.062l1.438.816-.054,15.353-1.437-.815Z",
  transform: "translate(-1171.614 -806.994)",
  fill: "#373737"
}), React.createElement("path", {
  id: "Path_330",
  "data-name": "Path 330",
  d: "M1178.818,862.389l1.437.815-7,4.069-1.437-.815Z",
  transform: "translate(-1171.763 -844.684)",
  fill: "#4d4c4c"
}), React.createElement("path", {
  id: "Path_331",
  "data-name": "Path 331",
  d: "M1171.668,877.705l1.438.815-.054,8.986-1.437-.815Z",
  transform: "translate(-1171.614 -855.931)",
  fill: "#373737"
})), React.createElement("path", {
  id: "Path_332",
  "data-name": "Path 332",
  d: "M1108.086,764.779l3.625,2.093,8.365-15.673-11.969-6.911Z",
  transform: "translate(-418.802 -342.908)",
  fill: "#fff",
  opacity: 0.6
}), React.createElement("path", {
  id: "Path_333",
  "data-name": "Path 333",
  d: "M1426.533,638.148l9.652-16.716-3.888-12.842-22.775,39.444Z",
  transform: "translate(-640.154 -243.262)",
  fill: "#fff",
  opacity: 0.6
}), React.createElement("path", {
  id: "Path_334",
  "data-name": "Path 334",
  d: "M1259.11,695.937l17.012-9.886,25.319-43.852-17.011,9.885Z",
  transform: "translate(-529.703 -267.941)",
  fill: "#fff",
  opacity: 0.6
}), React.createElement("path", {
  id: "Path_335",
  "data-name": "Path 335",
  d: "M1191.9,761.618l13.152-22.778-17.011,9.886-.029.049Z",
  transform: "translate(-477.494 -338.907)",
  fill: "#fff",
  opacity: 0.6
}), React.createElement("path", {
  id: "Path_336",
  "data-name": "Path 336",
  d: "M1352.246,702.57l2.927-1.7-8.088-26.715-2.927,1.7Z",
  transform: "translate(-592.156 -291.406)",
  fill: "#f6b918"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 319.997,
    height: 291.938,
    viewBox: "0 0 319.997 291.938"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/construction-vehicle.499ac38d.svg";
export { SvgComponent as ReactComponent };